exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@page{size:US-Letter;margin:0 0 35mm 0;background:#fff;font-size:16px}body{border-top:10px solid #1abc9c;font-size:16px;font-family:myriad-pro-1,myriad-pro-2,sans-serif}*{box-sizing:border-box}#container{margin:0 auto;max-width:8.5in;padding-bottom:10mm}table.el-table__body,table.el-table__header{max-width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71545e4e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/PrintLayout.vue
// module id = 508
// module chunks = 0